// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"b917c666","812":"2ae4bbed","906":"bd533fdf","922":"2d0b7d00"}[chunkId] + ".chunk.js";
};